<app-dialog [(visible)]="visible" header="Modifier le bien" width="640px">
  <form [formGroup]="form" (ngSubmit)="submit()" class="edit-form" id="property-edit-form">

    <div class="field field--full">
      <label for="pe-title">Titre *</label>
      <input pInputText id="pe-title" formControlName="title" [class.ng-dirty]="invalid('title')">
      @if (invalid('title')) { <small class="field-error">Le titre est obligatoire.</small> }
    </div>

    <div class="field">
      <label for="pe-type">Type *</label>
      <p-select inputId="pe-type" formControlName="type" [options]="typeOptions"
                optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" />
    </div>
    <div class="field">
      <label for="pe-tx">Transaction *</label>
      <p-select inputId="pe-tx" formControlName="transactionType" [options]="transactionOptions"
                optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" />
    </div>

    <div class="field">
      <label for="pe-price">Prix (FCFA) *</label>
      <p-inputnumber inputId="pe-price" formControlName="price" [min]="0" locale="fr-FR" styleClass="w-full" />
      @if (invalid('price')) { <small class="field-error">Prix obligatoire (≥ 0).</small> }
    </div>
    <div class="field">
      <label for="pe-surface">Surface (m²)</label>
      <p-inputnumber inputId="pe-surface" formControlName="surface" [min]="0" [maxFractionDigits]="2" locale="fr-FR" styleClass="w-full" />
    </div>

    <div class="field field--third">
      <label for="pe-pieces">Pièces</label>
      <p-inputnumber inputId="pe-pieces" formControlName="nbPieces" [min]="0" styleClass="w-full" />
    </div>
    <div class="field field--third">
      <label for="pe-bed">Chambres</label>
      <p-inputnumber inputId="pe-bed" formControlName="nbBedrooms" [min]="0" styleClass="w-full" />
    </div>
    <div class="field field--third">
      <label for="pe-bath">Salles de bain</label>
      <p-inputnumber inputId="pe-bath" formControlName="nbBathrooms" [min]="0" styleClass="w-full" />
    </div>

    <div class="field">
      <label for="pe-city">Ville *</label>
      <input pInputText id="pe-city" formControlName="city">
      @if (invalid('city')) { <small class="field-error">La ville est obligatoire.</small> }
    </div>
    <div class="field">
      <label for="pe-commune">Commune</label>
      <input pInputText id="pe-commune" formControlName="commune">
    </div>

    <div class="field field--full">
      <label for="pe-address">Adresse</label>
      <input pInputText id="pe-address" formControlName="address">
    </div>

    <div class="field field--full">
      <label for="pe-desc">Description</label>
      <textarea pTextarea id="pe-desc" formControlName="description" rows="4"></textarea>
    </div>

    <div class="field field--full">
      <label for="pe-features">Équipements <span class="hint">(séparés par des virgules)</span></label>
      <input pInputText id="pe-features" formControlName="features" placeholder="Piscine, Climatisation, Gardien">
    </div>

    <div class="field field--full field--inline">
      <p-toggleswitch inputId="pe-furnished" formControlName="isFurnished" />
      <label for="pe-furnished">Meublé</label>
    </div>
  </form>

  <div dialogFooter>
    <button pButton type="button" [text]="true" label="Annuler" (click)="visible.set(false)"></button>
    <button pButton type="submit" form="property-edit-form" icon="pi pi-check" label="Enregistrer"
            [loading]="saving()" [disabled]="saving()"></button>
  </div>
</app-dialog>
